import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';

// Define expected data structure for this node
interface GlobalConfigNodeData {
  label?: string;
  config?: any; // Placeholder for the actual global config object
}

const GlobalConfigNode: React.FC<NodeProps<GlobalConfigNodeData>> = ({ data }) => {
  const label = data?.label || 'Global Config';

  // Determine if there are filters, mappings, enrichments etc.
  const hasFilters = data?.config?.filters?.length > 0;
  const hasMappings = data?.config?.mappings?.length > 0;
  const hasEnrichments = data?.config?.enrichments?.length > 0;
  // Add checks for other global sections if needed

  return (
    <div className="playbook-node global-config-node" style={{ width: 200 }}>
      {/* Input handle from PlaybookRoot */}
      <Handle
        type="target"
        position={Position.Top}
        id="input"
        style={{ background: '#555' }}
      />
      <div className="playbook-node-header">
        <strong>{label}</strong>
      </div>
      <div style={{ padding: '5px 0', fontSize: '0.9em', color: '#555' }}>
        {/* Display summary of contained config */}
        {hasFilters && <div>Filters</div>}
        {hasMappings && <div>Mappings</div>}
        {hasEnrichments && <div>Enrichments</div>}
        {(!hasFilters && !hasMappings && !hasEnrichments) && <div>(Empty)</div>}
      </div>
      {/* Output handle (optional, could connect to a final output or debug node) */}
      <Handle
        type="source"
        position={Position.Bottom}
        id="output"
        style={{ background: '#555' }}
      />
    </div>
  );
};

export default GlobalConfigNode;
